import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 18 18", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.336 14.51a1.286 1.286 0 01-1.82 0l-4.24-4.24a1.288 1.288 0 011.82-1.82l3.33 3.33 8.477-8.478a1.288 1.288 0 011.82 1.82L7.336 14.51z" }));
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
